/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionW
 */
export interface SessionW {
    /**
     * comments
     * @type {string}
     * @memberof SessionW
     */
    comments: string;
    /**
     * start
     * @type {Date}
     * @memberof SessionW
     */
    start: Date;
    /**
     * end
     * @type {Date}
     * @memberof SessionW
     */
    end: Date;
}

/**
 * Check if a given object implements the SessionW interface.
 */
export function instanceOfSessionW(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "comments" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "end" in value;

    return isInstance;
}

export function SessionWFromJSON(json: any): SessionW {
    return SessionWFromJSONTyped(json, false);
}

export function SessionWFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionW {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comments': json['comments'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
    };
}

export function SessionWToJSON(value?: SessionW | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comments': value.comments,
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
    };
}

